import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { PageHeader } from '@ems/ui/patterns/page-header'

import { ActivityFeed } from '#admin/features/platform/activity/activity-feed.tsx'

/** `/platform/activity` — everything staff did in the console, newest first. */
export const Route = createFileRoute('/_authenticated/platform/activity')({
  staticData: { crumb: 'Activity' },
  validateSearch: (search: Record<string, unknown>): { action: string } => ({
    action: typeof search['action'] === 'string' ? search['action'].slice(0, 100) : '',
  }),
  component: ActivityPage,
})

function ActivityPage() {
  const { action } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <>
      <PageHeader
        title="Activity"
        description="Every act by platform staff — on editions, plans, series, payment methods and logins — with who and why."
      />
      <ActivityFeed
        action={action}
        onActionChange={(next) => void navigate({ search: { action: next }, replace: true })}
      />
    </>
  )
}
